module.exports = __webpack_public_path__ + "static/media/20ECE25.9b85b211.jpg";